/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'

const $nsid = 'app.bsky.graph.getFollows'

export { $nsid }

/** Enumerates accounts which a specified account (actor) follows. */
const main = l.query(
  $nsid,
  l.params({
    actor: l.string({ format: 'at-identifier' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    subject: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    cursor: l.optional(l.string()),
    follows: l.array(
      l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
